"use client";



export default function BaseDetailResponsiveAds() {
  // Premium base-page GAM placement now renders inside BaseArticle,
  // between meta/CC troops and strengths. This legacy hook stays as a
  // no-op to avoid duplicate base-page inventory.
  return null;
}
